import { getYesNoLabel, yesNoOptions } from '@Constants/selectOptions';
import { ApiAvv } from '@Model';
import { Column } from '@synqo/frontend-component-library';

export const avvColumns: Column<ApiAvv>[] = [
    { name: 'code', label: 'Code' },
    { name: 'description', label: 'Beschreibung' },
    {
        name: 'is_dangerous',
        label: 'Gefährlich',
        filterVariant: 'select',
        filterOptions: yesNoOptions,
        renderCell: ({ cellData }) => getYesNoLabel(cellData as boolean),
    },
];

/** AVVs have no label, so a linked field of them sorts by code instead of its default. */
export const avvSorting = { columnName: 'code', direction: 'asc' } as const;
